import { userSlice } from "@/redux/user/slice";

const actions = userSlice.actions;

export const {
	reset: resetUserState,
	setUserInfoFetchState,
	setUserInfoFetchRequest,
	setUserInfoFetchSuccess,
	setUserInfoFetchFailure,
} = actions;
